import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'ambassador-draft',
		path: '/ambassadors/:token',
		component: loadable(async () => import(/* webpackChunkName: "pages/ambassadors-draft" */ './index'), {
			exportName: 'AmbassadorDraft',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: false,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
